<template>
  <div class="bottomBox">
    <p>联系电话：13098823590</p>
    <p>企业邮箱：data@yiruibim.com</p>
    <p>地 址：湖北省武汉市武昌区武汉数创大厦23层</p>
    <p>Copyright © 2026 湖北毅瑞数据科技有限公司 | 版权所有</p>
    <div class="stl1">
      <p @click="handleOpen('1')">备案号：鄂ICP备20013150号-3</p>
      <div @click="handleOpen('2')" class="stl2">
        <img src="@/assets/images/备案图标.png" alt="" />
        <p>鄂公网安备 42018502005941号</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleOpen(val) {
      if (val == "1") {
        window.open("https://beian.miit.gov.cn/#/Integrated/index");
      } else if (val == "2") {
        window.open("https://beian.mps.gov.cn/#/query/webSearch");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bottomBox {
  padding: 30px 200px;
  box-sizing: border-box;
  background-color: rgb(0, 0, 0);
  p {
    color: rgba(255, 255, 255, 0.95);
    line-height: 20px;
    font-size: 14px;
  }
  .stl1 {
    display: flex;
    align-items: center;
    margin-top: 10px;
    p {
      margin-right: 40px;
      color: rgba(255, 255, 255, 0.65);
      cursor: pointer;
    }
    .stl2 {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        width: 25px;
        height: 25px;
      }
    }
  }
}
</style>
